import { commitMutation } from 'react-relay';
import environment from '../environment';

export default function callMutation(
  mutation,
  variables,
  callbacks,
  env = environment
) {
  return commitMutation(env, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      if (errors) {
        return callbacks.onFailure(errors) || callbacks;
      }
      return callbacks.onSuccess(response) || callbacks;
    },
    onError: err => callbacks.onFailure(err) || callbacks
  });
}
